<form [formGroup]="actionForm">
    <div class="row">
        <div class="col-lg-6">
            <div class="form-group">
                <label><strong>Action Owner</strong></label>
                <input type="text" class="form-control input-sm" formControlName="ownerNameCtrl" />
            </div>
            <div class="form-group">
                <label><strong>Action Type</strong></label>
                <kendo-combobox [data]="actionTypes"
                                [textField]="'actionTypeDescription'"
                                [valueField]="'actionTypeId'"
                                [valuePrimitive]="true"
                                [placeholder]="'Select an Action'"
                                [allowCustom]="false"
                                (selectionChange)="actionTypeChanged($event.value)"
                                formControlName="actionTypeCtrl"
                                [popupSettings]="{ appendTo: 'component' }">
                </kendo-combobox>
            </div>
            <div class="form-group">
                <label><strong>Event Date</strong></label>
                <kendo-datepicker formControlName="eventDateCtrl" required style="margin: 2px;" [popupSettings]="{ appendTo: 'component' }"></kendo-datepicker>
            </div>
            <div class="form-group" *ngIf="!addNewContact">
                <label><strong>Contact</strong></label>
                <kendo-combobox [data]="contacts"
                                [textField]="'fullName'"
                                [valueField]="'contactId'"
                                [valuePrimitive]="true"
                                [placeholder]="'Select a Contact'"
                                [allowCustom]="false"    
                                formControlName="contactCtrl"
                                [popupSettings]="{ appendTo: 'component' }">
                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span>{{dataItem.fullName}} - {{dataItem.phone}}</span>
                    </ng-template>
                </kendo-combobox>
                <button class="epi-button" (click)="$event.preventDefault(); addNewContact = !addNewContact;">Add</button>
                <br />
                <a href="tel:+1{{getContact().phone}}">{{getContact().phone}}</a>
                <br />
                <a href="mailto:{{getContact().email}}?body={{actionForm.controls['detailsCtrl'].value}}">{{getContact().email}}</a>
            </div>
            <div class="form-group" *ngIf="addNewContact" style="min-height: 275px;">
                <label><strong>Name</strong></label>
                <input type="text" class="form-control input-sm" [(ngModel)]="contactName" [ngModelOptions]="{standalone: true}" />

                <label><strong>Phone &amp; Ext</strong></label>
                <div class="col-lg-8">
                    <kendo-maskedtextbox [mask]="phoneMask" class="form-control input-sm" type="text" [(ngModel)]="contactPhone" [ngModelOptions]="{standalone: true}"></kendo-maskedtextbox>
                </div>
                <div class="col-lg-4">
                    <input type="text" class="form-control input-sm" [(ngModel)]="contactPhoneExt" [ngModelOptions]="{standalone: true}" />
                </div>

                <br/>
                <label><strong>Email</strong></label>
                <input type="text" class="form-control input-sm" [(ngModel)]="contactEmail" [ngModelOptions]="{standalone: true}" />

                <label><strong>Title</strong></label>
                <input type="text" class="form-control input-sm" [(ngModel)]="contactTitle" [ngModelOptions]="{standalone: true}" />

                <label style="color: red;"><strong>{{contactSaveMessage}}</strong></label>
                <button class="epi-button" (click)="$event.preventDefault(); saveContact();">Save Contact</button>
                <button class="epi-button" (click)="$event.preventDefault(); addNewContact = !addNewContact;">Cancel</button>
            </div>
            <div class="form-group">
                <label><strong>Opportunity</strong></label>
                <mat-select placeholder="Opportunity" formControlName="opportunityCtrl">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let opportunity of opportunities" [value]="opportunity.opportunityID">
                        {{opportunity.opportunityNotes == null ? opportunity.productDescription : opportunity.opportunityNotes}}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="col-lg-6">
                <div class="form-group">
                    <label><strong>Details</strong></label>
                    <textarea formControlName="detailsCtrl" class="form-control" rows="3" cols="50" placeholder="Enter Notes..." required></textarea>
                    <mat-error *ngIf="submitted && actionForm.controls['detailsCtrl'].hasError('required')">Please enter notes</mat-error>
                </div>
                <div class="form-group" *ngIf="followUpIsVisible">
                    <mat-checkbox formControlName="followUpCtrl">Follow Up</mat-checkbox>
                </div>
                <div class="form-group" *ngIf="followUpIsVisible">
                    <label><strong>Follow Up Date</strong></label>
                    <kendo-datepicker formControlName="followUpDateCtrl" required style="margin: 2px;" [popupSettings]="{ appendTo: 'component' }"></kendo-datepicker>
                </div>
                <div class="form-group" *ngIf="followUpIsVisible">
                    <label><strong>Assign To</strong></label>
                    <mat-select placeholder="Assign To" formControlName="assignToCtrl">
                        <mat-option>--</mat-option>
                        <mat-option *ngFor="let employee of employees" [value]="employee.employeeId">
                            {{employee.fullName}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="showAssignToMessage">Select an employee</mat-error>
                </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <button class="epi-button float-right" type="submit" (click)="saveAction()">Save</button>
            <p class="float-right">
                {{saveMessage}}
            </p>
        </div>
    </div>
</form>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': saving}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="saving"></mat-spinner>
</div>
